import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    selectedModelId: '',
    selectedCategoryId: '',
    modelList: [],
    trainedMessages: [],
    toBeTrainMessages: [],
    totalToBeTrainCount: [],
  },
  getters: {
    selectedModelId: (state) => state.selectedModelId,
    selectedCategoryId: (state) => state.selectedCategoryId,
    modelList: (state) => state.modelList,
    trainedMessages: (state) => state.trainedMessages,
    toBeTrainMessages: (state) => state.toBeTrainMessages,
    totalToBeTrainCount: (state) => state.totalToBeTrainCount,
    allModelTotalToBeTrainCount: (state) => {
      let total = 0;
      if (state.totalToBeTrainCount && state.totalToBeTrainCount.length > 0) {
        state.totalToBeTrainCount.forEach((countObj) => {
          total += countObj.total;
        });
      }
      return total;
    },
  },
  actions: {
    setSelectedModelId(context, params) {
      const { modelId } = params;
      context.commit('setSelectedModelId', modelId);
    },
    setSelectedCategoryId(context, params) {
      const { categoryId } = params;
      context.commit('setSelectedCategoryId', categoryId);
    },
    loadModelList(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadModelList()
          .then((response) => {
            const { data } = response.data;
            data.forEach((model) => {
              const newModel = model;
              if (newModel.lastTrainedAt) {
                newModel.isOutdated = newModel.updatedAt > newModel.lastTrainedAt;
              } else {
                newModel.isOutdated = true;
              }
            });
            context.commit('setModelListData', data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadCategoryList(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadCategoryList(modelId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadTrainedMessagePage(context, params) {
      const {
        modelId, categoryId, page, size, searchPhrase,
      } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadTrainedMessagePage(modelId, categoryId, page, size, searchPhrase)
          .then((response) => {
            context.commit('setTrainedMessagePageData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resetTrainedMessagePage(context) {
      context.commit('setTrainedMessagePageData', {});
    },
    trainModel(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice
          .trainModel(modelId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createToBeTrainMessage(context, params) {
      const { modelId, categoryId, message } = params;
      return new Promise((resolve, reject) => {
        alice
          .createToBeTrainMessage(modelId, categoryId, message)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createResolveToBeTrainMessage(context, params) {
      const { modelId, categoryId, message } = params;
      return new Promise((resolve) => {
        alice
          .createToBeTrainMessage(modelId, categoryId, message)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            resolve({ isError: true, error });
          });
      });
    },
    updateToBeTrainMessage(context, params) {
      const { messageId, data } = params;
      return new Promise((resolve, reject) => {
        alice
          .updateToBeTrainMessage(messageId, { ...data })
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadToBeTrainPage(context, params) {
      const {
        modelId, categoryId, page, size,
      } = params;
      return new Promise((resolve, reject) => {
        alice
          .getPageToBeTrainMessage(modelId, categoryId, page, size)
          .then((response) => {
            context.commit('setToBeTrainPageData', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resetToBeTrainPage(context) {
      context.commit('setToBeTrainPageData', {});
    },
    moveToTrainMessage(context, params) {
      const { modelId, categoryId } = params;
      return new Promise((resolve, reject) => {
        alice
          .moveToTrainMessage(modelId, categoryId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createQuestion(context, params) {
      const { modelId, categoryId, message } = params;
      return new Promise((resolve, reject) => {
        alice
          .createQuestion(modelId, categoryId, message)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    checkMessageStatus(context, params) {
      const { modelId, message } = params;
      return new Promise((resolve, reject) => {
        alice
          .checkMessageStatus(modelId, message)
          .then((response) => {
            resolve({
              status: response.data.data.status,
              modelId,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteTrainedMessage(context, params) {
      const { modelId, categoryId, questionId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteQuestion(modelId, categoryId, questionId)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteToBeTrainMessage(context, params) {
      const { messageId } = params;
      return new Promise((resolve, reject) => {
        alice
          .deleteToBeTrainMessage(messageId)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTotalToBeTrainCount(context) {
      return new Promise((resolve, reject) => {
        alice
          .getTotalToBeTrainCount()
          .then((response) => {
            context.commit('setTotalToBeTrainCountData', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setSelectedModelId(state, data) {
      Vue.set(state, 'selectedModelId', data);
    },
    setSelectedCategoryId(state, data) {
      Vue.set(state, 'selectedCategoryId', data);
    },
    setModelListData(state, data) {
      Vue.set(state, 'modelList', data);
    },
    setTrainedMessagePageData(state, data) {
      Vue.set(state, 'trainedMessages', data);
    },
    setToBeTrainPageData(state, data) {
      Vue.set(state, 'toBeTrainMessages', data);
    },
    setTotalToBeTrainCountData(state, data) {
      Vue.set(state, 'totalToBeTrainCount', data);
    },
  },
};
